"use client";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import ArrowIosDown from "@crehana/compass.icons.outline/ArrowIosDown";
import ArrowIosUp from "@crehana/compass.icons.outline/ArrowIosUp";
import CloseSmall from "@crehana/compass.icons.outline/CloseSmall";
import Filter from "@crehana/compass.icons.outline/Filter";
import { Chip } from "../Chip/index.js";
import { cn } from "../utils.js";
import { useDropdownContext } from "./context.js";
import { DropdownTrigger } from "./Dropdown.js";
const DropdownFilterButton = ({ children, multiselect, onClear, filterIcon, hideArrow, hideFilterIcon = false, displayCategoryAsLabel = false, className, ...props })=>{
    const { open, selectedItems, setValues, setOpen } = useDropdownContext();
    const selectedValueOnButton = ()=>{
        if (displayCategoryAsLabel) return selectedItems[1] && !multiselect ? selectedItems[1].label : void 0;
        return selectedItems[0] && !multiselect ? selectedItems[0].label : void 0;
    };
    const renderTrailingIcon = ()=>{
        if (selectedValueOnButton()) {
            const handleClear = (event)=>{
                event.stopPropagation();
                setValues([]);
                setOpen(false);
                if (onClear) onClear();
            };
            return /*#__PURE__*/ jsx("span", {
                onClick: handleClear,
                className: "tw-rounded-full tw-w-2 tw-h-2 group-hover:tw-bg-primary-light-500 group-hover:dark:tw-bg-secondary-light-500 tw-flex tw-items-center tw-justify-center",
                children: /*#__PURE__*/ jsx(CloseSmall, {
                    className: "group-hover:tw-text-neutral-light-100 tw-text-primary-light-500 dark:tw-text-secondary-light-500",
                    size: 16
                })
            });
        }
        if (open) return /*#__PURE__*/ jsx(ArrowIosUp, {
            className: "tw-text-inherit",
            size: 20
        });
        return /*#__PURE__*/ jsx(ArrowIosDown, {
            className: "tw-text-inherit",
            size: 20
        });
    };
    return /*#__PURE__*/ jsx(DropdownTrigger, {
        asChild: true,
        ...props,
        children: /*#__PURE__*/ jsxs("button", {
            role: "combobox",
            "aria-expanded": open,
            className: cn('tw-w-fit tw-group tw-h-3.6 tw-px-1.2 tw-flex tw-items-center tw-justify-between tw-font-link1 tw-gap-0.8 tw-transition-colors', 'tw-rounded-1 tw-border tw-border-solid tw-border-neutral-light-500 dark:tw-border-neutral-dark-700', 'tw-bg-neutral-light-100 dark:tw-bg-neutral-dark-700', 'tw-text-neutral-light-800 dark:tw-text-neutral-light-100', 'hover:tw-border-primary-light-500 hover:tw-text-primary-light-500 dark:hover:tw-border-secondary-light-500 dark:hover:tw-text-secondary-light-500', 'active:tw-bg-primary-light-500 active:tw-text-neutral-light-100 dark:active:tw-bg-secondary-light-500 dark:active:tw-text-elevation-dark-02', 'aria-expanded:tw-bg-primary-light-500 aria-expanded:tw-text-neutral-light-100 dark:aria-expanded:tw-bg-secondary-light-500 dark:aria-expanded:tw-text-elevation-dark-02', 'disabled:tw-bg-neutral-light-400 disabled:tw-text-neutral-light-600 disabled:tw-border-neutral-light-400 dark:disabled:tw-bg-neutral-dark-500 dark:disabled:tw-text-neutral-dark-600 dark:disabled:tw-border-neutral-dark-500', Boolean(selectedValueOnButton) && 'tw-border-primary-light-500 tw-text-primary-light-500 dark:tw-border-secondary-light-500 dark:tw-text-secondary-light-500', className),
            children: [
                !hideFilterIcon && (filterIcon ?? /*#__PURE__*/ jsx(Filter, {
                    className: "tw-text-inherit",
                    size: 16
                })),
                selectedValueOnButton() ?? children,
                !hideArrow && renderTrailingIcon()
            ]
        })
    });
};
const DropdownFilterValues = ({ removeAllButtonCount = 4, clearSelectionLabel = 'Borrar todo', onSelectChange })=>{
    const { selectedItems, items, setValues } = useDropdownContext();
    if (items[0]?.type === 'option') throw new Error("Option values aren't still not developed for DropdownFilterValues. Please do it manually.");
    const handleItemRemoved = (value)=>{
        const newSelectedItems = selectedItems.filter((item)=>item.value !== value);
        const newValues = newSelectedItems.map((item)=>item.value);
        setValues(newValues);
        if (onSelectChange) onSelectChange(newValues);
    };
    const handleClearAll = ()=>{
        setValues([]);
        if (onSelectChange) onSelectChange([]);
    };
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            selectedItems.map((item)=>/*#__PURE__*/ jsx(Chip, {
                    variant: "close",
                    onClose: ()=>handleItemRemoved(item.value),
                    children: item.label
                }, item.value)),
            removeAllButtonCount > 0 && selectedItems.length >= removeAllButtonCount && /*#__PURE__*/ jsx(Chip, {
                className: "tw-text-primary-light-400 dark:tw-text-secondary-dark-300 tw-border-primary-light-400 dark:tw-border-secondary-dark-300",
                variant: "choices",
                onClick: handleClearAll,
                children: clearSelectionLabel
            })
        ]
    });
};
export { DropdownFilterButton, DropdownFilterValues };
